import { render, staticRenderFns } from "./PorZona.vue?vue&type=template&id=0cd57fe9&scoped=true&lang=pug&"
import script from "./PorZona.vue?vue&type=script&lang=js&"
export * from "./PorZona.vue?vue&type=script&lang=js&"
import style0 from "./PorZona.vue?vue&type=style&index=0&id=0cd57fe9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd57fe9",
  null
  
)

export default component.exports